export default __webpack_public_path__ + "static/media/tmdb_logo.bb8aa703.svg";